// extracted by css-extract-rspack-plugin
export default {"cls1":"Playlist-cls1_5-A","cls2":"Playlist-cls2_Raw Playlist-cls1_5-A"};